import React, { useEffect, useRef } from 'react';
import { Alert } from "react-bootstrap";
import SpellError from 'src/components/util/spell-error';

const renderField = ({
  input,
  label,
  type,
  classgroup,
  classinput,
  meta: { touched, error, warning }
}) => (
  <div className={classinput}>
    <input className="form-control" placeholder={label} type={type} {...input} />
    {error}
    {/* {touched && (error && <span className='redux-form-error-message'>{error}</span>)} */}
    {/* {touched &&
          ((error && <span>{error}</span>) ||
            (warning && <span>{warning}</span>))} */}
    <div className="input-group-append">
      <div className="input-group-text">
        <span className={classgroup}></span>
      </div>
    </div>
  </div>
);

const renderFormField = ({
  input,
  label,
  type,
  classgroup,
  classinput,
  idinput,
  readonly,
  meta: { touched, error, warning },
  maxLength
}) => (
  <div className={classgroup}>
    <label htmlFor={idinput}>{label}</label>
    <input readOnly={readonly} type={type} className={(error && touched) ? `${classinput} is-invalid` : `${classinput}`} id={idinput} placeholder={label} maxLength={maxLength} {...input} />
    
  </div>
);

const renderFormFieldAppend = ({
  input,
  label,
  type,
  disabled,
  classinput,
  classappend,
  idinput,
  meta: { touched, error, warning }
}) => (
  <div>
    <label htmlFor={idinput}>{label}</label>
    <div className="input-group">
      <input autoComplete="bvxhewtfdg" disabled={disabled || false} type={type} className={(touched && error) ? 'form-control is-invalid' : 'form-control'} id={idinput} placeholder={label}  {...input} />
      <div className="input-group-append">
        <div className="input-group-text">
          <span className={classappend}></span>
        </div>
      </div>
      {touched &&
        ((error && <span className="error invalid-feedback">{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </div>
  </div>
);

const renderTextAreaField = ({
  input,
  label,
  type,
  classgroup,
  classinput,
  idinput,
  readonly,
  meta: { touched, error, warning, asyncValidating },
  maxLength,
  onKeyUp, // Không cần onKeyUp, thay bằng onInput
}, props) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // Reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Điều chỉnh height
    }
  }, [input.value]); // Chạy mỗi khi giá trị thay đổi

  return (
    <div className="form-group">
      <label>{label}</label>
      <div className={asyncValidating ? "async-validating" : ""}>
        <textarea
          ref={textareaRef}
          readOnly={readonly}
          className={`form-control ${classinput}`}
          maxLength={maxLength}
          placeholder={label}
          rows={3} // Bắt đầu với 1 hàng
          {...input}
          onInput={(e) => {
            input.onChange(e); // Giữ chức năng của Redux Form
          }}
          style={{ resize: "none", minHeight: "72px", overflow: "hidden" }} // Chặn resize thủ công
        ></textarea>

        {touched && (
          <>
            {warning && <span>{warning}</span>}
            {error && error.required && (
              <span className="text-danger">{error.required}</span>
            )}
            {error && error.spell && (
              <SpellError spellData={error.spell} className="mt-2" />
            )}
          </>
        )}
      </div>
    </div>
  );
};

const renderKeywordField = ({
  input,
  label,
  type,
  classgroup,
  classinput,
  idinput,
  readonly,
  meta: { touched, error, warning, asyncValidating },
  maxLength,
  onKeyUp
}, props) => (
  <div className="form-group">
    <label>{label}</label>
    <div className={asyncValidating ? 'async-validating' : ''}>
      <textarea
        readOnly={readonly}
        className="form-control"
        rows="3"
        maxLength={maxLength}
        placeholder={label}
        {...input}
        onKeyUp={onKeyUp}
      ></textarea>
      {touched &&
        <>
          {warning && <span>{warning}</span>}
          {error && error.required && <span className="text-danger">{error.required}</span>}
        {error && (error.titleHasKeyword || error.titleGoogleHasKeyword || error.descriptionHasKeyword || error.descriptionGoogleHasKeyword) && 
          <Alert className="mt-2" variant="warning" >
            <Alert.Heading as="h6">Lưu ý về SEO</Alert.Heading>
            {error && error.titleHasKeyword && <p className="mb-1">- {error.titleHasKeyword}</p>}
            {error && error.titleGoogleHasKeyword && <p className="mb-1">- {error.titleGoogleHasKeyword}</p>}
            {error && error.descriptionHasKeyword && <p className="mb-1">- {error.descriptionHasKeyword}</p>}
            {error && error.descriptionGoogleHasKeyword && <p className="mb-1">- {error.descriptionGoogleHasKeyword}</p>}
          </Alert>
        }
          
        </>
      }

    </div>
  </div>
);

const renderRadioField = ({
  input,
  label,
  type,
  classgroup,
  classinput,
  idinput,
  meta: { touched, error, warning }
}) => (
  <div className="form-group">
    <label>{label}</label>
    <textarea className="form-control" rows="3" placeholder={label} {...input}></textarea>
  </div>
);

const formatPrice = (value, name) => {
  if(!value) return 0;
  if(isNaN(parseInt(value))) return 0
  return value
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
};

const normalizePrice = (value, previousValue, allValues, previousAllValues, name) => {
  if(!value) return 0;
  const valueInt = value.replaceAll(".","");
  if(isNaN(parseInt(valueInt))) return 0
  else return parseInt(valueInt);

  
};

export {
  renderField,
  renderFormField,
  renderTextAreaField,
  renderRadioField,
  renderFormFieldAppend,
  renderKeywordField,
  formatPrice,
  normalizePrice
}

